import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { AfterViewInit, Component, Input, ViewEncapsulation } from "@angular/core";
import { ConfirmationService, MenuItem } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SubSink } from "subsink";
import { PpsUtilityService } from "../services/pps-utility.service";
import { RosterTypeService } from "../services/roster-type.service";
import { IRosterType } from "../shared/models/roster/roster-type";
import { IRosterCode } from "../shared/models/roster-code";
import { ToastService } from "../shared/toast/toast.service";
import { RosterTypeFormComponent } from "./roster-type-form.component";
import { IRosterCodeSetting } from "../shared/models/roster-code-setting";

@Component({
  selector: "pps-manage-roster-type",
  templateUrl: "./manage-roster-type.component.html",
  styles: [`
    :host {
      display: block;
      height: 100%;
      min-height: 0;
      overflow: hidden;
    }

    .roster-type-page {
      height: 100%;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    .roster-type-toolbar {
      flex: 0 0 auto;
    }

    .roster-type-scroll {
      flex: 1 1 auto;
      min-height: 0;
      overflow: auto;
      padding: 0 1rem 1rem 1rem;
    }

    .roster-type {
      margin-top: 1rem;
    }

    .roster-type .p-message-custom {
      background-color: #e1cfe7;
      border: solid #8a427a;
      border-width: 0 0 0 6px;
      color: #2c1e30;
    }

    .roster-type .p-fieldset{
      border: 1px solid #aaaaaa !important;
      -webkit-box-shadow: 4px 4px 10px 0px rgba(64,64,64,0.3) !important;
      -moz-box-shadow:    4px 4px 10px 0px rgba(64,64,64,0.3) !important;
      box-shadow:         4px 4px 10px 0px rgba(64,64,64,0.3) !important;       
    }

    .roster-type .p-fieldset .p-fieldset-legend{
      /*
      font-size: 1.2rem;
      background: var(--indigo-600) !important;
      background: linear-gradient(135deg, var(--indigo-600) 0%, var(--indigo-300) 50%, var(--indigo-200) 75%, var(--indigo-300) 100%) !important;
      */
    }
    /*
    .roster-type .p-fieldset-legend-text,
    .roster-type .p-fieldset-toggler{
      color: white !important;
    }
    */
  `],
  encapsulation: ViewEncapsulation.None
})
export class ManageRosterTypeComponent{
  private subs = new SubSink();
  smallScreen: boolean = false;
  
  collapseAll: boolean = true;

  @Input() rosterTypes: IRosterType[] = [];
  @Input() rosterCodes: IRosterCode[] = [];
  @Input() rosterCodeSettings: IRosterCodeSetting[] = [];

  constructor(
    private _rosterTypeService: RosterTypeService,
    private _dialog: DialogService,
    private _toast: ToastService,
    private _util: PpsUtilityService,
    private _confirm: ConfirmationService,
    private breakpointObserver: BreakpointObserver){
    this.subs.sink = this.breakpointObserver.observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.smallScreen = !state.matches;
      });

  }

  ngOnInit(){
  }
  
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }    

  getDescription(desc){
    return (desc || "").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br />");
  }

  deleteRosterType(rosterType: IRosterType){
    this._confirm.confirm({
      key: "rt-dialog",
      header: `Delete Roster Type`,
      message: `Please confirm that you want to delete this roster type [${rosterType.title}]?`,
      icon: "fas fa-exclamation-circle icon-danger",
      defaultFocus: "accept",
      accept: () => this.deleteRosterTypeHelper(rosterType)
    });
  }

  private deleteRosterTypeHelper(rosterType: IRosterType){
    this.subs.sink = this._rosterTypeService.delete(rosterType.id)
    .subscribe(res => {
      if (res.succeed){
        var index = this.rosterTypes.findIndex(rt=>rt.id === rosterType.id);
        if (index !== -1){
          this.rosterTypes.splice(index, 1);
          this._toast.succeeded(`Roster type ${rosterType.title} deleted.`);
        }
      }else{
        this._toast.failed(`Delete roster type failed: ${res.errors.join(";")}`);
      }
    });
  }

  addOrUpdateRosterType(rosterType: IRosterType){
    let create = rosterType === null;

    let dialog = this._dialog.open(RosterTypeFormComponent, {
      header: `Edit Roster Type`,
      styleClass: "size-sm",
      data:{
        rosterType: rosterType,
        rosterCodes: this.rosterCodes
      },
      draggable: true
    });
    
    this.subs.sink = dialog.onClose.subscribe(
      result => {
        if (result){
          if (!create){
            this.subs.sink = this._rosterTypeService.update(result)
              .subscribe(res => {
                if (res.succeed){
                  var index = this.rosterTypes.findIndex(rt=>rt.id === res.result.id);
                  if (index !== -1){
                    this.rosterTypes[index] = this._util.deepCopy(res.result);
                  }

                  this._toast.succeeded(`Roster type ${rosterType.title} updated.`);
                }else{
                  this._toast.failed(`Delete roster type failed: ${res.errors.join(";")}`);
                }
              });
          }else{
            this.subs.sink = this._rosterTypeService.add(result)
              .subscribe(res => {
                if (res.succeed){
                  this.rosterTypes.unshift(this._util.deepCopy(res.result));
                  this._toast.succeeded(`Roster type ${res.result.title} created.`);
                }else{
                  this._toast.failed(`Delete roster type failed: ${res.errors.join(";")}`);
                }
              });
          }
        }
      },
      reason => {
      }
    );
  }
}